












































































































import { Vue, Component, Prop, Emit, Watch } from "vue-property-decorator";
import Element, { ElementType, SpecyficType } from "@/models/element";
import SvgIcon from "@/components/SvgIcon.vue";
import { shaderTranslator } from "@/models/shaders/util/shaderTranslator.ts";
import { FurnitureManager } from "@/models/furnitureManager.ts";
import { ProductDetailsManager } from "@/models/productDetailsManager.ts";

@Component({
  components: {
    SvgIcon,
  },
})
export default class ProductDialog extends Vue {
  @Prop({ type: Object, required: false }) productData: any | null;
  @Prop({ type: Object, required: false }) productGraphics: object | null;
  @Prop({ type: String, required: false }) productName: string | null;
  @Prop({ type: String, required: false }) productPrice: string | null;
  @Prop({ type: Boolean, required: false }) isProductCorrect: boolean | null;
  @Prop({ type: Boolean, required: false }) useAllImages: boolean | null;
  @Prop({ type: Boolean, required: true }) opened: boolean;

  private productDetailsManager: ProductDetailsManager;
  private productDetails: any;

  private close(): void {
    this.$emit("dialogClose");
  }

  private confirm(): void {
    this.productData.productDetails = this.productDetails;
    this.$emit("confirm", this.productData, this.productGraphics);
  }

  private created() {
    this.productDetailsManager = new ProductDetailsManager(this.productData);
    this.productDetails = this.productDetailsManager.crete();
  }

  @Watch("opened")
  private onOpenedChanged(val, old) {
    if (val) {
      this.productDetailsManager = new ProductDetailsManager(this.productData);
      this.productDetails = this.productDetailsManager.crete();
    }
  }

  private lazy: string =
    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAADICAQAAAAHUWYVAAABKUlEQVR42u3RMQEAAAjDMKYc6WCCgyOV0GS69KgAASIgQAQEiIAAERAgAiIgQAQEiIAAERAgAiIgQAQEiIAAERAgAiIgQAQEiIAAERAgAiIgQAQEiIAAERAgAiIgQAQEiIAAERAgAiIgQAQEiIAAERAgAiIgQAQEiIAAERAgAiIgQAQEiIAAERAgAiIgQAQEiIAAERAgAgLEBCACAkRAgAgIEAEBIiACAkRAgAgIEAEBIiACAkRAgAgIEAEBIiACAkRAgAgIEAEBIiACAkRAgAgIEAEBIiACAkRAgAgIEAEBIiACAkRAgAgIEAEBIiACAkRAgAgIEAEBIiACAkRAgAgIEAEBIiBAgAARECACAkRAgAgIEAERECACAkRAgAgIEAERECACAkSXLZ1yK0hKBJiuAAAAAElFTkSuQmCC";
}
